// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-light[data-v-26a4e27d]{background-color:#fafbfc}.shift-row-item[data-v-26a4e27d]{border:1px solid #edf2f7;-webkit-transition:all .2s ease;transition:all .2s ease}.shift-row-item[data-v-26a4e27d]:hover{border-color:#cbd5e1}[dir=rtl] .contentinfo[data-v-26a4e27d],[dir=rtl] .rowinfo[data-v-26a4e27d]{text-align:right}", ""]);
// Exports
module.exports = exports;
